module.exports = __webpack_public_path__ + "img/bigLine.2c408038.png";